import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import IconClose from 'components/icons/iconClose';
import { colorWhite } from 'styles/layout/colors';
const MobileNavbarHiddenCloseButton = t0 => {
  const $ = _c(4);
  const {
    onClick
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconClose className="MobileNavbarHiddenCloseButton__icon" color={colorWhite} height="16" width="16" />;
    t2 = <VisuallyHidden>Close</VisuallyHidden>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClick) {
    t3 = <button className="[background:none] border-0 rounded-[3px] opacity-0 p-2 pointer-events-none focus-visible:opacity-100 focus-visible:outline-white" onClick={onClick} type="button">{t1}{t2}</button>;
    $[2] = onClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
MobileNavbarHiddenCloseButton.propTypes = {
  onClick: PropTypes.func
};
export default MobileNavbarHiddenCloseButton;